import { render } from "./UploadedFile.vue?vue&type=template&id=6cb7506d&scoped=true"
import script from "./UploadedFile.vue?vue&type=script&lang=js"
export * from "./UploadedFile.vue?vue&type=script&lang=js"

import "./UploadedFile.vue?vue&type=style&index=0&id=6cb7506d&scoped=true&lang=scss"

import exportComponent from "/working_dir/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6cb7506d"]])

export default __exports__